import { Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import {  Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { KmpmasterService } from 'src/app/services/kmpmaster.service';
import { environment } from 'src/environments/environment';
declare var $: any;
var moment = require('moment');

@Component({
  selector: 'app-kmpdetails',
  templateUrl: './kmpdetails.component.html',
  styleUrls: ['./kmpdetails.component.css']
})
export class KMPDetailsComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterKMP: DataTables.Settings = {};
  dtOptionsOfRegisterKMP: DataTables.Settings = {};
  masterKmpList: any[];
  registerKmpList: any[];
  dtTriggerMasterKMP: Subject<any> = new Subject();
  dtTriggerRegisterKMP: Subject<any> = new Subject();
  ToDateModelInMasterKMP: any;
  FromDateModelInMasterKMP: any;
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response:boolean;
  isSearchDivVisible = false;
  constructor(private KmpMasterService: KmpmasterService, private router: Router, 
    private commonFunction: CommonFunction,private route: ActivatedRoute) {
    this.response = false;
   }

   toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  ngOnInit() {

    this.environmentSettings = environment;

    this.getMasterKmpList();
    this.getRegisterKmpList();
    this.FromDateModelInMasterKMP = null;
    this.ToDateModelInMasterKMP = null;

    this.dtOptionsOfMasterKMP = {
      destroy: true,
      scrollY: "220px",
      scrollX: true,
      scrollCollapse: true,
      deferRender: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [6] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'KMP List',
          title: 'KMP List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2,3,4,5],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }

        }
      ]
    };

    this.dtOptionsOfRegisterKMP = {
      destroy: true,
      scrollY: "220px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Register of KMP List',
          title: 'Register of KMP List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }

        }
      ]
      
    };
    let searchflag = localStorage.getItem('searchkmpflag');
    var filterDate;
    if (searchflag == 'true') {
      
      filterDate = JSON.parse(localStorage.getItem('inputdata'));
    
      if(filterDate.FromDate !=null){
      let dt = new Date(this.commonFunction.setFormatDate(filterDate.FromDate))
      this.FromDateModelInMasterKMP ={ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      }
      if(filterDate.ToDate !=null){
      let dt2 = new Date(this.commonFunction.setFormatDate( filterDate.ToDate))
      this.ToDateModelInMasterKMP = { month: dt2.getMonth() + 1, day: dt2.getDate(), year: dt2.getFullYear() }
      }
    }
    else {
      filterDate = {
        FromDate: null,
        ToDate: null,
      }
    }

  }

  adjustkmpmasterTable() {
    var kmpData = this.masterKmpList;
    console.log('kmpData',kmpData)
    if(kmpData.length){
      console.log(11)
    this.masterKmpList = [];
    $("#kmpmasterTable").DataTable().destroy();
    this.masterKmpList = kmpData;
    this.dtTriggerMasterKMP.next();
    setTimeout(() => {
      $("#kmpmasterTable").DataTable().columns.adjust().draw();
    }, 200);
  }
  }

  getMasterKmpList() {
    this.masterKmpList = [];

    let searchflag = localStorage.getItem('searchkmpflag');
    var filterDate;
    if (searchflag == 'true') {
      
      filterDate = JSON.parse(localStorage.getItem('inputdata'));
    

      let dt = new Date(this.commonFunction.setFormatDate(filterDate.FromDate))
      this.FromDateModelInMasterKMP ={ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      let dt2 = new Date(this.commonFunction.setFormatDate( filterDate.ToDate))
      this.ToDateModelInMasterKMP = { month: dt2.getMonth() + 1, day: dt2.getDate(), year: dt2.getFullYear() }
    }
    else {
      filterDate = {
        FromDate: null,
        ToDate: null,
      }
    }
    // var filterDate = {
    //   FromDate: null,
    //   ToDate: null,
    // }
    this.KmpMasterService.getMasterKmp(filterDate)
      .subscribe(masterKmpList => {
        this.masterKmpList = (masterKmpList && masterKmpList.status == 0 && masterKmpList.kmpmaster)
          ? masterKmpList.kmpmaster
          : [];
        this.dtTriggerMasterKMP.next();
      }, () => {
        this.masterKmpList = [];
        this.dtTriggerMasterKMP.next();
      });
  }

  loadKmpDetailsById(kmpId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['KMP', 'edit',kmpId]  } }],
      { relativeTo: this.route.parent });

    // this.router.navigate(['/KMP/edit/', kmpId]);
  }

  getRegisterKmpList() {
      
    this.registerKmpList = [];
    this.KmpMasterService.getRegisterKmp()
      .subscribe(registerList => {
          
        if (registerList && registerList.status == 0 && registerList.registerkmp) {
          for (var i = 0; i < registerList.registerkmp.length; i++) {
            if (registerList.registerkmp[i].Kmpship.length > 0 ||
              registerList.registerkmp[i].SubKmp.length > 0) {
              this.registerKmpList.push(registerList.registerkmp[i]);
            }
          }

          for (var i = 0; i < this.registerKmpList.length; i++) {

            if (this.registerKmpList[i].RegisterKmpStatusList[this.registerKmpList[i].RegisterKmpStatusList.length - 1] == 'Rectified') {
              this.registerKmpList[i].authStatus = this.registerKmpList[i].RegisterKmpStatusList[this.registerKmpList[i].RegisterKmpStatusList.length - 2];
            } else {
              this.registerKmpList[i].authStatus = this.registerKmpList[i].RegisterKmpStatusList[this.registerKmpList[i].RegisterKmpStatusList.length - 1];
            }
          }
        }

        this.dtTriggerRegisterKMP.next();
      }, () => {
        this.registerKmpList = [];
        this.dtTriggerRegisterKMP.next();
      });
  }

  loadauthorizeData(kmpId) {
    var authenticate = "authenticate";
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['registerKMP', 'edit',kmpId,authenticate]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/registerKMP/edit/', kmpId, authenticate]);
  }

  loadrectifyData(kmpId) {
      
    var rectify = "rectify";
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['registerKMP', 'edit',kmpId,rectify]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/registerKMP/edit/', kmpId, rectify]);
  }

  getKMPByParam() {
    this.response = true;
    localStorage.setItem('searchkmpflag', 'true');
    
    this.masterKmpList = [];
    var filterDate = {
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInMasterKMP != null && this.ToDateModelInMasterKMP == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInMasterKMP).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInMasterKMP == null && this.ToDateModelInMasterKMP != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInMasterKMP).toString();
    }
    if (this.FromDateModelInMasterKMP != null && this.ToDateModelInMasterKMP != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInMasterKMP).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInMasterKMP).toString();
    }
    if (this.FromDateModelInMasterKMP == null && this.ToDateModelInMasterKMP == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }

    localStorage.setItem('inputdata', JSON.stringify(filterDate));
    
    // var table = $('#kmpmasterTable').DataTable({ destroy: true });
    // table.destroy();
    this.KmpMasterService.getMasterKmp(filterDate)
      .subscribe(masterKMPData => {
        if (masterKMPData.status == 0) {
          this.masterKmpList = masterKMPData.kmpmaster;
          this.response = false;
        }
      });
    // this.dtTriggerMasterKMP.next();

    this.adjustkmpmasterTable();
  }


  getKMPByNullParam() {
    this.response = true;

    localStorage.setItem('searchkmpflag', 'false');
    
    this.futureFromDate = null;
    this.futureToDate = null;
    this.FromDateModelInMasterKMP = null;
    this.ToDateModelInMasterKMP = null;
    this.masterKmpList = [];

    var filterDate = {
      FromDate: null,
      ToDate: null,
    }

    // var table = $('#kmpmasterTable').DataTable({ destroy: true });
    // table.destroy();
    this.KmpMasterService.getMasterKmp(filterDate)
      .subscribe(masterKMPData => {
        if (masterKMPData.status == 0) {
          this.masterKmpList = masterKMPData.kmpmaster;
          this.response = false;
          
        }
      });
    // this.dtTriggerMasterKMP.next();


    this.adjustkmpmasterTable();
  }

  tabRegisterOfKMPOnClickEvent() {
    setTimeout(() => {
      $("#kmpRegisterTable").DataTable().columns.adjust().draw();
    });
  }

  setTodate(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDate = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdate(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDate = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }
}

